import { environment } from "../environments/environment";

export class Globals {
  static isDevEnv = !environment.production;
  static localhostUrl = `http://localhost:4200`;
  static originUrl = environment.originUrl;
  static apiTimeout = 10000;
  static dataCollectionMessageOrigins = new Set([
    'https://centinelapi.cardinalcommerce.com',
    'https://centinelapistag.cardinalcommerce.com',
    'https://client.cardinaltrusted.com',
  ]);

  static isLocalhost(): boolean {
    return window.location.hostname === 'localhost';
  }

  /*
    Necesitamos navegación manual para que callbacks de flutter
    detecten cambios de URL. Client-side routing con router.navigate( .. )
    no funciona para este fin.
  */
  static manuallyNavigateTo(path: string): void {
    let fullUrl: string;
    if (Globals.isDevEnv && Globals.isLocalhost()) {
      fullUrl = `${Globals.localhostUrl}${path}`;
    } else {
      fullUrl = `${Globals.originUrl}${path}`;
    }
    window.location.href = fullUrl;
  }

  /* Largo del BIN evaluado (primeros dígitos del PAN) */
  static readonly binLength = 6;

  /*
    BINes habilitados explícitamente: ganan por sobre las reglas de
    no soportados, para poder liberar casos puntuales sin tocar la regla.
  */
  static get supportedBins(): string[] {
    return [];
  }

  /* BINes que no pueden ser tokenizados y deben inscribirse vía Webpay */
  static get unsupportedBins(): string[] {
    return [
      '000000',
      '456931',
      '522416', // LOS ANDES TARJETAS DE PREPAGO SA - Tapp - CARD_NOT_ELIGIBLE
      '539032', // Banco Internacional
    ];
  }

  /*
    Prefijos no tokenizables. "3" cubre las marcas distintas de VISA y
    Mastercard (principalmente AMEX).
  */
  static get unsupportedBinPrefixes(): string[] {
    return [
      '3'
    ];
  }

  /*
    Determina si el BIN ingresado no puede ser tokenizado. Se evalúa recién
    cuando hay dígitos suficientes para conformar el BIN, para no derivar
    al usuario a Webpay mientras aún está escribiendo el número.
  */
  static isUnsupportedBin(cardNumber: string): boolean {
    const digits = String(cardNumber ?? '').replace(/\D/g, '');
    if (digits.length < Globals.binLength) return false;

    const bin = digits.slice(0, Globals.binLength);
    if (Globals.supportedBins.includes(bin)) return false;
    if (Globals.unsupportedBins.includes(bin)) return true;

    return Globals.unsupportedBinPrefixes.some(prefix => bin.startsWith(prefix));
  }

  static sanitizeForLog(data: any): string {
    if (!data) return 'null/undefined';
    const safe: Record<string, any> = {};
    if (data.status !== undefined) safe.status = data.status;
    if (data.status_code !== undefined) safe.status_code = data.status_code;
    if (data.name) safe.name = data.name;
    if (data.message) safe.message = data.message;
    if (data.error?.status_code) safe.error_status_code = data.error.status_code;
    return JSON.stringify(safe);
  }

}